export default __webpack_public_path__ + "static/media/empty-marks.4366f78b.png";